
import { defineComponent } from "vue";
import logoColor from "@/assets/img/hs_logo_color.svg";
import logoWhite from "@/assets/img/hs_logo.svg";

export default defineComponent({
  name: "AppLogo",
  props: {
    mode: {
      type: String,
      default: "light",
    },
    imgClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    logoSrc(): string {
      return this.mode === "dark" ? logoWhite : logoColor;
    },
    resolvedClass(): string {
      return this.imgClass || "w-full h-auto";
    },
  },
});
